/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */

/**
 * Service class for managing keyboard shortcuts for various components such as PDF viewers
 * and image viewers.
 */
class KeyboardShortcutsService {
  /**
   * Return true if target event is from <body> or <div> (and is nit composing) or in popup.
   * @param event
   * @param isPopupOpen
   */
  isDivBody(event, isPopupOpen) {
    return (
      ["BODY", "DIV"].includes(event.target.nodeName) &&
      !isPopupOpen &&
      !event.isComposing
    );
  }

  /**
   * Push keyboard Event to PdfComponent
   * @param pdfComponent
   */
  eventPdfComponent(pdfComponent, event) {
    if (!pdfComponent) {
      return;
    }
    switch (event.key) {
      case "ArrowLeft":
        pdfComponent.previousPage();
        break;
      case "ArrowRight":
        pdfComponent.nextPage();
        break;
      case "+":
        pdfComponent.zoomIn();
        break;
      case "-":
        pdfComponent.zoomOut();
        break;
      case "5":
        pdfComponent.fitWidthAuto();
        break;
      case "0":
        pdfComponent.fitAuto();
        break;
    }
  }

  /**
   * Push keyboard Event to ImageViewer
   * @param imgViewer
   */
  eventImageViewer(imgViewer, event) {
    if (!imgViewer) {
      return;
    }
    switch (event.key) {
      case "+":
        imgViewer.zoomIn();
        break;
      case "-":
        imgViewer.zoomOut();
        break;
      case "0":
        imgViewer.fitAuto();
        break;
    }
  }
}

export default new KeyboardShortcutsService();
